import { get } from './index';

const localMode = process.env.REACT_APP_LOCAL_MODE === 'true';

let principal = null;

export const getPrincipal = async () => {
    if (!principal) {
        if (localMode) {
            return new Promise(resolve => {
                setTimeout(() => {
                    principal = require('./mock-data/principal.json');
                    resolve(principal);
                }, 200);
            });
        } else {
            principal = await get(`/principal`);
        }
    }

    return principal;
};